export const GET_ALL_SUGGESTIONS = 'GET_ALL_SUGGESTIONS';
export const CREATE_SUGGESTION = 'CREATE_SUGGESTION';